$('.js-hidden').on('click', function () {
  $('.js-popup-hidden').hide();
});


// WEBPACK FOOTER //
// ./src/js/general/hidden.js